import React from 'react';
import { useDolphin } from '../../hooks/useDolphin';
import { FaUsers, FaGift } from 'react-icons/fa';

export default function AdminAnalytics() {
  const { userStats, analytics } = useDolphin();

  return (
    <section className="admin-analytics">
      <h2 className="dashboard-title">
        <span className="icon-wrapper"><FaUsers className="icon-faded" /></span> Referral Analytics
      </h2>
      <div className="referral-stats-row">
        <div className="featured-stat-card">
          <FaUsers className="referral-stat-icon" />
          <div>
            <span className="featured-stat-label">Direct Referrals</span>
            <span className="featured-stat-value">{userStats.referrals || 0}</span>
          </div>
        </div>
        <div className="featured-stat-card">
          <FaGift className="referral-stat-icon" />
          <div>
            <span className="featured-stat-label">Earnings</span>
            <span className="featured-stat-value">{((userStats.referralEarnings || 0) / 1e6).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USDT</span>
          </div>
        </div>
        {userStats.indirectReferrals !== undefined && (
          <div className="featured-stat-card">
            <FaUsers className="referral-stat-icon icon-faded" />
            <div>
              <span className="featured-stat-label">Indirect Referrals</span>
              <span className="featured-stat-value">{userStats.indirectReferrals}</span>
            </div>
          </div>
        )}
      </div>
      {analytics && (
        <div className="referral-analytics-row">
          <div className="featured-stat-card">
            <span className="featured-stat-label">Levels</span>
            <span className="featured-stat-value">{analytics.levels || 0}</span>
          </div>
          <div className="featured-stat-card">
            <span className="featured-stat-label">Downlines</span>
            <span className="featured-stat-value">{analytics.downlines || 0}</span>
          </div>
          <div className="featured-stat-card">
            <span className="featured-stat-label">Vesting</span>
            <span className="featured-stat-value">{analytics.vesting || 0} DOLP</span>
          </div>
        </div>
      )}
      {/* <ReferralEarningsCalculator /> removed: not exported anymore */}
    </section>
  );
}
